import { render, staticRenderFns } from "./storePriceManage.vue?vue&type=template&id=633ae76a&scoped=true"
import script from "./storePriceManage.vue?vue&type=script&lang=js"
export * from "./storePriceManage.vue?vue&type=script&lang=js"
import style0 from "./storePriceManage.vue?vue&type=style&index=0&id=633ae76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ae76a",
  null
  
)

export default component.exports